<template>
    <vx-card title="Rating Bidang Pelayanan" :subtitle="ratingPerbidang.periode">
        <global-wrapper :loading="loading" :loadingList="3">
            <div class="w-full flex items-center mb-3" v-for="(data,index) in ratingPerbidang.rating" :key="index">
                <vs-avatar :text="avatarName(index)" :color="avatarColor(index)" class="mr-5" size="40px"></vs-avatar>
                <div class="flex-1">
                    <div class="font-bold">Bidang {{data.nama_bidang}}</div>
                    <star-rating :star-size="20" :rating="parseFloat(data.rating)" :read-only="true" :round-start-rating="false" :border-width="1" border-color="#d8d8d8" :rounded-corners="true" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"></star-rating>
                </div>
            </div>
        </global-wrapper>
    </vx-card>
</template>

<script>
import StarRating from 'vue-star-rating'
import {mapState} from 'vuex'

export default {
    components :{
        StarRating
    },
    mounted(){
        this.fetchDataRatingPerbidang()
    },
    data(){
        return {
            loading : false
        }
    },
    methods : {
        async fetchDataRatingPerbidang(){
            this.loading = true
            await this.$store.dispatch('dashboard/fetchDataRatingPerbidang');
            this.loading = false
        },
        avatarName(val){
            let data = parseInt(val) + 1
            return `${data}`
        },
        avatarColor(val){
            let index = this.avatarName(val)
            switch(index){
                case "1" : 
                    return "#ffd055";
                case "2" :
                    return "#B4B4B4";
                case "3" :
                    return "#AD8A56";
                default : 
                    return "#ffd055";
            }
        }
    },
    computed:{
        ...mapState({
            ratingPerbidang : (state) => state.dashboard.kinerja.ratingPerbidang
        })
    }
}
</script>